import { render, staticRenderFns } from "./ProjectTypeNew.vue?vue&type=template&id=66fced77&"
import script from "./ProjectTypeNew.vue?vue&type=script&lang=js&"
export * from "./ProjectTypeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports